/**
 * The theme, and the fact that it survives a reload.
 *
 * The first paint is handled by an inline script in index.html; this keeps the
 * document and the stored preference in step afterwards.
 */
import { useCallback, useEffect, useState } from "react";

import {
  applyTheme,
  nextTheme,
  readStoredTheme,
  resolveTheme,
  storeTheme,
  type Theme,
} from "@/design-system/theme";

export function useTheme(): { readonly theme: Theme; readonly toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(() =>
    resolveTheme(readStoredTheme(window.localStorage)),
  );

  useEffect(() => {
    applyTheme(theme, document.documentElement);
    storeTheme(theme, window.localStorage);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme(nextTheme);
  }, []);

  return { theme, toggle };
}
